<template>
  <div class="patient-info-container">
    <div class="patient-info-content">
      <h3 class="sidebar-title">Paciente</h3>
      <h6 class="patient-info-title" v-if="programData.patient">
        {{programData.patient.first_name}}
        {{programData.patient.last_name}}
      </h6>
      <div class="row" v-if="programData.patient">
        <p class="col-12 patient-info-data">
          Rut:
          <span v-if="programData.patient.rut">{{programData.patient.rut}}</span>
          <span v-else>--</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="programData.patient.sex">{{programData.patient.sex}}</span>
          <span v-else>Sexo: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="programData.patient.birth">{{programData.patient.birth}}</span>
          <span v-else>Nacido: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="programData.patient.height">{{programData.patient.height}} cms</span>
          <span v-else>Altura: --</span>
        </p>
        <p class="col-6 patient-info-data">
          <span v-if="programData.patient.weight">{{programData.patient.weight}} kgs</span>
          <span v-else>Peso: --</span>
        </p>
      </div>
      <div v-if="programData.patient_poll" class="mt-3">
        <h6 class="patient-info-title">Antecedentes</h6>
        <p class="patient-info-data">
          Motivación:
          <span
            v-if="programData.patient_poll.motivation"
          >{{programData.patient_poll.motivation}}</span>
          <span v-else>No especificada</span>
        </p>
        <p class="patient-info-data">
          Intensidad:
          <span
            v-if="programData.patient_poll.intensity"
          >{{programData.patient_poll.intensity}}</span>
          <span v-else>No especificada</span>
        </p>
        <p class="patient-info-data">
          Tiempo:
          <span
            v-if="programData.patient_poll.exercise_time"
          >{{programData.patient_poll.exercise_time}}</span>
          <span v-else>No especificado</span>
        </p>
        <p class="patient-info-data">
          Tipo:
          <span
            v-if="programData.patient_poll.exercise_type"
          >{{programData.patient_poll.exercise_type}}</span>
          <span v-else>No especificado</span>
        </p>
        <p class="patient-info-data">
          <span
            v-if="programData.patient_poll.times_week"
          >{{programData.patient_poll.times_week}} veces por semana</span>
          <span v-else>Veces por semana no especificado</span>
        </p>
        <h6 class="patient-info-title">Disponibilidad</h6>
        <p class="patient-info-data">
          Días:
          <span v-if="programData.patient_poll.days">{{programData.patient_poll.days}}</span>
          <span v-else>No especificado</span>
        </p>
        <p class="patient-info-data">
          Tiempo por día:
          <span
            v-if="programData.patient_poll.time_per_day"
          >{{programData.patient_poll.time_per_day}}</span>
          <span v-else>No especificado</span>
        </p>
        <p class="patient-info-data">
          Lugar:
          <span v-if="programData.patient_poll.place">{{programData.patient_poll.place}}</span>
          <span v-else>No especificado</span>
        </p>
        <p class="patient-info-data">
          Herramientas:
          <span
            v-if="programData.patient_poll.tools"
          >{{programData.patient_poll.tools}}</span>
          <span v-else>No marcó ninguna opción</span>
        </p>
        <p class="patient-info-data">
          Puede comprar:
          <span
            v-if="programData.patient_poll.buy_tools"
          >{{programData.patient_poll.buy_tools}}</span>
          <span v-else>No especificado</span>
        </p>
      </div>
      <h6 class="patient-info-title">Observaciones</h6>
      <p class="patient-info-data" v-if="programData.patient_poll">
        <span v-if="programData.patient_poll.observation">{{programData.patient_poll.observation}}</span>
        <span v-else>Sin observaciones</span>
      </p>
    </div>
    <div class="patient-info-button-container">
      <button type="button" class="btn btn-info btn-sm btn-block">Ver ficha completa</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PatientInfo",
  props: ["programData"]
};
</script>

<style scoped lang="scss">
.patient-info-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.patient-info-content {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;

  & button {
    margin-top: 1rem;
  }
}

.patient-info-button-container {
  padding-top: 1rem;
}

.patient-info-title {
  margin-top: 1.25rem;
  margin-bottom: 0.6rem;
  font-size: $font-size-sm;

  &:first-child {
    margin-top: 0;
  }
}

.patient-info-data {
  padding-top: 0.25rem;
  padding-bottom: 0.1rem;
  margin: 0;
  line-height: 1.2;
  font-size: $font-size-sm;
}

.patient-info-separator {
  margin: 2rem 0;
  height: 0;
  background-color: $gray-300;
}
</style>